<template>
  <v-menu
    ref="menu"
    v-model="menu"
    transition="scale-transition"
    offset-y
    min-width="290px"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="date"
        :label="label"
        prepend-icon="event"
        :error-messages="errorMessages"
        readonly
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable @input="menu = false"/>
  </v-menu>
</template>

<script>
import {format, parseISO} from 'date-fns'
export default {
  name: 'DateSelector',
  props: {
    label: {required: false, default: ''},
    value: {required: false, default: null},
    errorMessages: {required: false, default: () => []}
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    date: {
      get() {
        return this.value ? format(parseISO(this.value), 'yyyy-MM-dd') : null
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<style>

</style>